import type { HTMLAttributes, ReactNode, TdHTMLAttributes, ThHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

/**
 * Обикновена HTML таблица. Единадесет буса и петдесетина заявки месечно не
 * заслужават виртуализация — тя само чупи Ctrl+F и достъпността.
 */
export function Table({ className, ...rest }: HTMLAttributes<HTMLTableElement>) {
  return (
    <div className="w-full overflow-x-auto">
      <table className={cn('w-full border-collapse text-sm', className)} {...rest} />
    </div>
  );
}

export function THead({ className, ...rest }: HTMLAttributes<HTMLTableSectionElement>) {
  return (
    <thead
      className={cn('sticky top-0 z-10 bg-surface text-[11px] uppercase tracking-wide text-ink-faint', className)}
      {...rest}
    />
  );
}

export function TBody(props: HTMLAttributes<HTMLTableSectionElement>) {
  return <tbody {...props} />;
}

export function TR({
  className,
  interactive = false,
  ...rest
}: HTMLAttributes<HTMLTableRowElement> & { interactive?: boolean }) {
  return (
    <tr
      className={cn(
        'border-b border-line last:border-b-0',
        interactive && 'cursor-pointer hover:bg-raised focus-within:bg-raised',
        className,
      )}
      {...rest}
    />
  );
}

export function TH({
  className,
  numeric = false,
  ...rest
}: ThHTMLAttributes<HTMLTableCellElement> & { numeric?: boolean }) {
  return (
    <th
      scope="col"
      className={cn(
        'border-b border-line px-3 py-2 text-left font-medium',
        numeric && 'text-right',
        className,
      )}
      {...rest}
    />
  );
}

export function TD({
  className,
  numeric = false,
  ...rest
}: TdHTMLAttributes<HTMLTableCellElement> & { numeric?: boolean }) {
  return (
    <td
      className={cn('px-3 py-2 align-middle', numeric && 'text-right font-mono tabular', className)}
      {...rest}
    />
  );
}

export function TableEmpty({ colSpan, children }: { colSpan: number; children: ReactNode }) {
  return (
    <tr>
      <td colSpan={colSpan} className="px-3 py-10 text-center text-sm text-ink-dim">
        {children}
      </td>
    </tr>
  );
}
